import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "loader plus"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", { class: "plus-icon" }, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "plus-icon" }, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "loader"
}

import IconUI from './IconUI.vue'

interface Props {
  dittoPlus?: boolean,
  iconFill?: string,
}


export default /*#__PURE__*/_defineComponent({
  __name: 'LoaderUI',
  props: {
    dittoPlus: { type: Boolean, default: false },
    iconFill: { default: 'info' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_ctx.dittoPlus)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_4))
    : (_openBlock(), _createElementBlock("div", _hoisted_5, [
        _createVNode(IconUI, {
          name: "loading",
          title: "Loading",
          fill: _ctx.iconFill
        }, null, 8, ["fill"])
      ]))
}
}

})